module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","addMinutes"],"commonjs":"date-fns/add_minutes/index","commonjs2":"date-fns/add_minutes/index"}
// module id = 48
// module chunks = 0